export default __webpack_public_path__ + "static/media/analytics.a9fd1d40.svg";